<template>
  <div class="part-container" v-if="prartName">
    <div class="part">
      <span @click="goPage()">{{prartName}}</span>
    </div>
  </div>
</template>

<script>
import { checkLinkUrl } from "../../utils/utils";
export default {
  name: "PartLine",
  data() {
    return {
      visitStatus: false
    };
  },
  props: {
    partItem: {
      type: null,
      observer: function(newVal, oldVal) {
        var that = this;
      }
    },
    currentPath:{
      type: String,
      default: ""
    },
    showPart: {
      type: Boolean,
      default: ""
    },
    prartName: {
      type: String,
      default: ""
    }
  },
  components: {},
  methods: {
    goPage(item) {
      this.menuShow = false;
      var that = this;
      if (that.partItem.friendlyUrl) {
        let params = {
          newWindows: that.partItem.newOpen,
          link:
            "/" +
            that.partItem.prefixLevelLink +
            "/" +
            that.partItem.friendlyUrl
        };
        checkLinkUrl(function(data) {}, params, that);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.part-container {
  // padding-top: 3rem;
  .part {
    border-top: 0.1rem solid #eaeaea;
    padding-top: 2rem;
    padding-bottom: 2rem;
    text-align: center;
    border-bottom: none;
    font-family: ArialNarrow, sans-serif;
    span:hover {
      color: #5c5d5f;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
/deep/ .eyewear.SUNGLASSES{
  .part{
    color: #fff!important;
    border-top: none!important;
  }
}
.eyewear.SUNGLASSES{
  .part{
    color: #fff!important;
    border-top: none!important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/PartLine.vue